import { useState } from "react";
import {
  CheckCircleFill,
  Bullseye,
  People,
  Lightbulb,
  InfoCircle
} from "react-bootstrap-icons";

export default function Intro() {
  const [showMore, setShowMore] = useState(false);

  return (
    <section id="welcome" className="py-5 section-tint">
      <div className="py-4 main-wrap">
        <div className="row justify-content-center">
          <div className="col-lg-9 col-xl-8">
            <div className="card border-0 shadow-sm rounded-4">
              <div className="card-body p-4 p-md-5 text-center">
                <h2 className="h1 fw-semibold mb-3">
                  Welcome to iRise Psychology
                </h2>

                <hr className="mx-auto my-3 w-25 opacity-25" />

                <p className="brand-text-gray fs-5 mb-4">
               A supportive collaborative psychology service helping individuals and couples better understand themselves, develop new perspectives and create meaningful lasting change.
                </p>

                <div className="mx-auto text-start d-inline-block mb-4">
                  <div className="d-flex align-items-start mb-3 brand-text-gray">
                    <CheckCircleFill className="fs-4 me-3 brand-text-light flex-shrink-0" />
                    <span className="fs-5">
                 Individual and couples therapy
                    </span>
                  </div>

                  <div className="d-flex align-items-start mb-3 brand-text-gray">
                    <CheckCircleFill className="fs-4 me-3 brand-text-light flex-shrink-0" />
                    <span className="fs-5">
                  Safe, respectful and collaborative approach
                    </span>
                  </div>

                  <div className="d-flex align-items-start brand-text-gray">
                    <CheckCircleFill className="fs-4 me-3 brand-text-light flex-shrink-0" />
                    <span className="fs-5">
            Support tailored to your needs
                    </span>
                  </div>
                </div>

                <div className={showMore ? "text-start mb-4" : "d-none"}>
                  <div className="d-flex align-items-start mb-4 brand-text-gray">
                    <InfoCircle className="fs-4 me-3 brand-text-light flex-shrink-0" />
                    <p className="fs-6 mb-0">
                    iRise Psychology is a London based psychology and therapy service offering thoughtful effective support for a range of psychological difficulties.
                    </p>
                  </div>

                  <div className="d-flex align-items-start mb-3 brand-text-gray">
                    <Bullseye className="fs-4 me-3 brand-text-light flex-shrink-0" />
                    <p className="fs-6 mb-0">
                 Our aim is to support you in reaching your full potential through therapy that is collaborative, compassionate and tailored to your individual needs. We work with individuals, couples and organisations, creating a safe respectful space where meaningful change can develop at your own pace.
                    </p>
                  </div>

                  <div className="d-flex align-items-start mb-3 brand-text-gray">
                    <People className="fs-4 me-3 brand-text-light flex-shrink-0" />
                    <p className="fs-6 mb-0">
                      We are passionate about psychology and committed to providing therapy that feels supportive, purposeful and worthwhile, recognising how emotional experience shapes relationships, work and connection.
                    </p>
                  </div>

                  <div className="d-flex align-items-start brand-text-gray">
                    <Lightbulb className="fs-4 me-3 brand-text-light flex-shrink-0" />
                    <p className="fs-6 mb-0">
                  Our work focuses on helping people better understand themselves, reshape unhelpful patterns and develop new perspectives that support lasting and positive change.
                    </p>
                  </div>
                </div>

                <div className="mt-4">
                  <button
                    type="button"
                    className="btn btn-brand-primary btn-lg px-4 fw-bold"
                    onClick={() => setShowMore((x) => !x)}
                    aria-expanded={showMore}
                  >
                    {showMore ? "Show less" : "Learn more"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
